import type { InputHTMLAttributes, ReactNode } from 'react';

import { describedBy } from './a11y';
import { Field } from './field';

interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label: ReactNode;
  error?: string | undefined;
  hint?: ReactNode;
}

export function TextField({ id, label, error, hint, className, ...input }: TextFieldProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error}>
      <input
        id={id}
        className={`input ${className ?? ''}`}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy(id, Boolean(hint), Boolean(error))}
        {...input}
      />
    </Field>
  );
}
